import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ReaReport } from '../../../core/models/domain.models';

@Injectable({ providedIn: 'root' })
export class NrpcReaReportsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl.replace(/\/+$/, '');

  fetch(payload: {
    source_url: string;
    title?: string | null;
    report_month?: number | null;
    report_year?: number | null;
    report_type?: string;
    rpc_region?: string;
    force_refetch?: boolean;
  }) {
    return this.http.post<ReaReport>(`${this.baseUrl}/api/nrpc-rea-reports/fetch`, payload, { withCredentials: true });
  }

  refetch(reportId: string) {
    return this.http.post<ReaReport>(`${this.baseUrl}/api/nrpc-rea-reports/${reportId}/refetch`, {}, { withCredentials: true });
  }
}
